import { languageList, useTranslation } from '@pancakeswap/localization'
import { NextLinkFromReactRouter, Menu as UikitMenu, footerLinks, useModal } from '@pancakeswap/uikit'
import USCitizenConfirmModal from 'components/Modal/USCitizenConfirmModal'
import { useCadinuPriceState, useCbonPriceState } from '@pancakeswap/utils/useCakePrice'
import { usePhishingBanner } from '@pancakeswap/utils/user'
import PhishingWarningBanner from 'components/PhishingWarningBanner'
import { useActiveChainId } from 'hooks/useActiveChainId'
import useTheme from 'hooks/useTheme'
import { IdType } from 'hooks/useUserIsUsCitizenAcknowledgement'
import { useRouter } from 'next/router'
import { useMemo } from 'react'
import GlobalSettings from './GlobalSettings'
import HeaderSearch from './HeaderSearch'
import { SettingsMode } from './GlobalSettings/types'
import UserMenu from './UserMenu'
import WrongNetworkPill from './WrongNetworkPill'
import { bottomNavItems } from './config/config'
import { useMenuItems } from './hooks/useMenuItems'
import { getActiveMenuItem, getActiveSubMenuItem } from './utils'

const LinkComponent = (linkProps) => {
  return <NextLinkFromReactRouter to={linkProps.href} {...linkProps} prefetch={false} />
}

const Menu = (props) => {
  const { chainId } = useActiveChainId()
  const { isDark, setTheme } = useTheme()
  // const cakePriceUsd = useCakeBusdPrice({ forceMainnet: true })
  // undefined while loading / unavailable -> the uikit price pill is hidden instead of showing $0
  const cadinuPriceState = useCadinuPriceState()
  const cbonPriceState = useCbonPriceState()
  const cakePriceUsd = cadinuPriceState.price?.toNumber()
  const cbonPriceUsd = cbonPriceState.price?.toNumber()
  const { currentLanguage, setLanguage, t } = useTranslation()
  const { pathname } = useRouter()
  const [onUSCitizenModalPresent] = useModal(
    <USCitizenConfirmModal title={t('PancakeSwap Perpetuals')} id={IdType.PERPETUALS} />,
    true,
    false,
    'usCitizenConfirmModal',
  )
  const [showPhishingWarningBanner] = usePhishingBanner()

  const menuItems = useMenuItems(onUSCitizenModalPresent)

  const activeMenuItem = getActiveMenuItem({ menuConfig: menuItems, pathname })
  const activeSubMenuItem = getActiveSubMenuItem({ menuItem: activeMenuItem, pathname })
  // the phone bar has its own five slots (Markets · Compete · Swap · Pools · More) and so its own active tab: on /u that is More,
  // where Profile lives on a phone
  const bottomNav = useMemo(() => {
    const links = bottomNavItems(menuItems)
    const active = getActiveMenuItem({ menuConfig: links, pathname })
    return { links, activeItem: active?.href, activeSubItem: getActiveSubMenuItem({ menuItem: active, pathname })?.href }
  }, [menuItems, pathname])

  const toggleTheme = useMemo(() => {
    return () => setTheme(isDark ? 'light' : 'dark')
  }, [setTheme, isDark])

  const getFooterLinks = useMemo(() => {
    return footerLinks(t)
  }, [t])

  return (
    <>
      <UikitMenu
        linkComponent={LinkComponent}
        rightSide={
          <>
            {/* token search on every page (Bez, 2026-10-04): a field from 1366 px (1260 until 2026-10-07), a button that opens it over the bar below */}
            <HeaderSearch />
            <GlobalSettings mode={SettingsMode.GLOBAL} />
            {/* BNB Chain only (2026-10-03): no network dropdown; a switch button only while the wallet is on another chain */}
            <WrongNetworkPill />
            <UserMenu />
          </>
        }
        chainId={chainId}
        banner={showPhishingWarningBanner && typeof window !== 'undefined' && <PhishingWarningBanner />}
        isDark={isDark}
        toggleTheme={toggleTheme}
        currentLang={currentLanguage.code}
        langs={languageList}
        setLang={setLanguage}
        cakePriceUsd={cakePriceUsd}
        cbonPriceUsd={cbonPriceUsd}
        links={menuItems}
        bottomNav={bottomNav}
        subLinks={activeMenuItem?.hideSubNav || activeSubMenuItem?.hideSubNav ? [] : activeMenuItem?.items}
        footerLinks={getFooterLinks}
        activeItem={activeMenuItem?.href}
        activeSubItem={activeSubMenuItem?.href}
        buyCakeLabel={t('Buy Cadinu')}
        buyCakeLink="https://apps.cadinu.io/swap?outputCurrency=0x76e112203eF59D445452ef7556386dD2DF3Ed914&chainId=56"
        {...props}
      />
    </>
  )
}

export default Menu
